<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/zhhqbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'高校宿舍管理系统'"></detailBread>
        <div class="container">
        <div class="page-title">
            高校宿舍管理系统
        </div>
        <div class="page-content" style="text-align:left;width:1000px;margin:0 auto;">
            <p>目前很多高校学生宿舍管理中，后勤部门还停留在宿舍管理人员手工记录数据的初级阶段，手工记录麻烦、费时，而且效率低。学生入住的过程中学生住宿的信息得不到有效的更新，同时学生经常会更换宿舍等等。无法保证学生住宿信息的完整性。</p>
            <p>在数字化校园的浪潮中，宿舍作为学生活动的主要场所，对传统的宿舍管理进行信息化建设是非常必要的。</p>
            <p>经过充分的调研，针对传统宿舍管理手段宿舍分配繁琐、审批时间长、信息更新不及时等情况导致的宿管工作效率低下，人力成本高等问题，昂克高校宿舍管理系统提供了一套完整的信息化解决方案，旨在让高校减少宿管的人力投资，减轻宿管工作负担，从繁杂的人工劳动中解脱出来，提高管理能力的层次，达到小成本，高回报的管理效果。</p>
            <p style=" font-size: 18px; font-weight: bold;">产品特点</p>
            <p>1. 界面友好，操作简单</p>
            <p>2. 查询条件灵活，多维度查询，统计报表强大</p>
            <p>3. 系统支持记录的批量处理：批量生成房间、批量退宿、批量入住等</p>
            <p>4. 系统提供了实用的图表分析功能、提供了公寓房间的床位分配情况</p>
            <p>5. 宿舍楼信息，宿舍信息，床位信息全覆盖</p>
            <p>6. 通过浏览器页面进行显示，操作简便</p>
            <p>7. 具备较强的兼容性和可扩展性，集成到数字化校园运行</p>
            <p>8. 实现数据实时更新，满足管理人员对学校住宿情况的实时掌握</p>
            <p>9. 全面覆盖学校宿舍管理涉及的各方面信息，满足宿舍管理业务流程</p>
            <p>10. 提供宿舍辅助管理功能，使宿舍管理更加完善</p>
        </div>
    </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '高校宿舍管理系统', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '高校宿舍管理系统'
        },
        {
            name: 'description',
            content: '高校宿舍管理系统'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'1',
        }
    },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
.page-content p {
    margin-bottom: 18px;
    font-size: 16px;
    line-height: 30px;
    text-indent: 28px;
}
</style>


// WEBPACK FOOTER //
// src/pages/old/gxssglxt.vue